import type { FC } from 'react';
import { renderToString } from 'react-dom/server';
import { type IControl, type MapInstance, useControl } from 'react-map-gl/mapbox';
import { IconLock, IconLockOpen } from 'src/components/Icon';
type OnMapLockToggle = (locked: boolean) => void;

class LockControlClass implements IControl {
  _map: MapInstance | undefined;
  _container: HTMLElement | null = null;
  _button: HTMLButtonElement | null = null;
  _locked = false;
  _onToggle?: OnMapLockToggle;

  constructor(onToggle?: OnMapLockToggle) {
    this._onToggle = onToggle;
  }
  onAdd(map: MapInstance) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group-vertical mapboxgl-ctrl-group';
    this._container.addEventListener('contextmenu', (e) => e.preventDefault());
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.title = 'Lock / Unlock Map';
    btn.style.fontSize = '1.3em';
    btn.style.paddingTop = '4px';
    btn.addEventListener('click', () => this.toggleLock());
    this._button = btn;
    this._container.appendChild(btn);
    this.updateButton();
    return this._container;
  }
  onRemove() {
    // Ensure map is unlocked when the control is removed
    this._container?.parentNode?.removeChild(this._container);
    this._map = undefined;
    this._button = null;
  }
  updateButton() {
    if (!this._button) return;
    const icon = this._locked ? <IconLock /> : <IconLockOpen />;
    this._button.innerHTML = renderToString(icon);
  }
  toggleLock() {
    if (!this._onToggle) {
      throw new Error('LockControl: onMapLockToggle handler is not defined.');
    }
    this._locked = !this._locked;
    try {
      this._onToggle(this._locked);
    } catch (err) {
      console.error('LockControl: onMapLockToggle handler threw an error:', err);
    }
    this.updateButton();
  }
}
export const LockControl: FC<{ onMapLockToggle?: OnMapLockToggle }> = ({ onMapLockToggle }) => {
  useControl<LockControlClass>(() => new LockControlClass(onMapLockToggle), {
    position: 'top-right',
  });
  return null;
};
